document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('[data-iv-header]');
  var toggle = document.querySelector('[data-iv-mobile-toggle]');
  var closeBtn = document.querySelector('[data-iv-mobile-close]');
  var mobileNav = document.querySelector('[data-iv-mobile-nav]');

  if (header) {
    var onScroll = function () {
      if (window.scrollY > 40) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    };
    document.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      mobileNav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }
  if (closeBtn && mobileNav) {
    closeBtn.addEventListener('click', function () {
      mobileNav.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  // ---------- Quick View ----------
  var quickViewModal = document.querySelector('[data-iv-quick-view-modal]');
  var quickViewBody = document.querySelector('[data-iv-quick-view-body]');

  function openModal(el) {
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeModal(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-iv-quick-view-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var handle = btn.getAttribute('data-product-handle');
      if (!handle || !quickViewModal || !quickViewBody) return;
      quickViewBody.innerHTML = '<div class="iv-modal__loading iv-utility">Loading…</div>';
      openModal(quickViewModal);

      fetch('/products/' + handle + '.js')
        .then(function (res) { return res.json(); })
        .then(function (product) {
          var variantOptions = product.variants.map(function (v) {
            return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' +
              v.title + (v.available ? '' : ' — Sold out') + '</option>';
          }).join('');

          quickViewBody.innerHTML =
            '<div class="iv-quick-view">' +
              '<div><img src="' + (product.featured_image || '') + '" alt="' + product.title + '"></div>' +
              '<div>' +
                '<p class="iv-eyebrow">' + (product.type || 'IV Collection') + '</p>' +
                '<h2 class="iv-display iv-display--md">' + product.title + '</h2>' +
                '<p class="iv-product__price">' + (product.price / 100).toLocaleString(undefined, {style:'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'}) + '</p>' +
                '<form action="/cart/add" method="post" enctype="multipart/form-data" class="iv-product__form">' +
                  (product.variants.length > 1 ? '<select name="id" aria-label="Variant">' + variantOptions + '</select>' : '<input type="hidden" name="id" value="' + product.variants[0].id + '">') +
                  '<button type="submit" class="iv-btn iv-btn--solid">Add to Cart</button>' +
                '</form>' +
                '<a href="/products/' + handle + '" class="iv-utility iv-mt-md" style="display:inline-block; text-decoration:underline;">View full details</a>' +
              '</div>' +
            '</div>';
        })
        .catch(function () {
          quickViewBody.innerHTML = '<p class="iv-utility" style="text-align:center;">Could not load product. <a href="/products/' + handle + '">View product page</a>.</p>';
        });
    });
  });

  document.querySelectorAll('[data-iv-modal-close]').forEach(function (btn) {
    btn.addEventListener('click', function () { closeModal(quickViewModal); });
  });

  // ---------- Size Guide drawer ----------
  var sizeGuideDrawer = document.querySelector('[data-iv-size-guide-drawer]');
  document.querySelectorAll('[data-iv-size-guide-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function () { openModal(sizeGuideDrawer); });
  });
  document.querySelectorAll('[data-iv-drawer-close]').forEach(function (btn) {
    btn.addEventListener('click', function () { closeModal(sizeGuideDrawer); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeModal(quickViewModal);
      closeModal(sizeGuideDrawer);
    }
  });
});
